// import { useEffect, useState } from 'react';

// export const setCookie = (name: string, value: string, expiresInDays: number = 1): void => {
//   const d = new Date();
//   d.setTime(d.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
//   const expires = 'expires=' + d.toUTCString();
//   document.cookie = `${name}=${value}; ${expires}; path=/`;
// };

// export const storeToken = (token: string): void => {
//   try {
//     setCookie('token', token, 1);
//   } catch (err) {
//     console.error('Failed to store token:', err);
//   }
// };

// export const deleteCookie = (name: string): void => {
//   document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
// };

// export const getCookie = (name: string): string | null => {
//   if (typeof document === 'undefined') return null;
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop()!.split(';').shift() ?? null;
//   return null;
// };

// export const useDebounce = <T>(value: T, delay: number): T => {
//   const [debouncedValue, setDebouncedValue] = useState<T>(value);
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);
//     return () => clearTimeout(handler);
//   }, [value, delay]);
//   return debouncedValue;
// };


import { useEffect, useState } from 'react';

export const setCookie = (name: string, value: string, expiresInDays: number = 1): void => {
  const d = new Date();
  d.setTime(d.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(';').shift() ?? null;
  return null;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const storeToken = (token: string): void => {
  try {
    setCookie('token', token, 1);
  } catch (err) {
    console.error('Failed to store token:', err);
  }
};

export const storeImpersonationToken = (token: string): void => {
  try {
    sessionStorage.setItem('imp_token', token);
  } catch (err) {
    console.error('Failed to store impersonation token:', err);
  }
};

export const getImpersonationToken = (): string | null => {
  try {
    return sessionStorage.getItem('imp_token');
  } catch (err) {
    return null;
  }
};

export const getActiveToken = (): string | null =>
  getImpersonationToken() || getCookie('token');

export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};